// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/pic-label/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/pic-label/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "PIC Labeling" })
  return <Page />
}
